import React from "react";
import Container from "react-bootstrap/Container";
import Alert from "./Alert";
import {Table} from "react-bootstrap";
import Storage from "./Storage";
import Logout, {FormatCents} from "./utils";
import JwtClient from "./JwtClient";

export default class BillingUSPS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formAlert: '',
            listAlert: '',
            formSubmitting: false,
            userCreatingBill: '',
            listLoading: false,
            bills: [],
            billCandidates: [],
        };
    }

    render() {
        return (
            <Container>
                <h4 className="mt-4">Billing USPS</h4>
                {this.state.formAlert ? <Alert>{this.state.formAlert}</Alert> :
                    this.state.billCandidates.length === 0 ? null :
                        <Table>
                            <tbody>
                            {
                                this.state.billCandidates.map((v, i) => {
                                    return (
                                        <tr key={i}>
                                            <td className="col-8"><b>{v.user}</b>: {v.package_ids.length} not billed
                                                packages, total
                                                cost ~{FormatCents(v.total_carrier_delivery_cents)}$
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-primary col-4"
                                                    disabled={this.state.formSubmitting || this.state.formAlert}
                                                    onClick={() => {
                                                        this.setState({userCreatingBill: v.user})
                                                        this.newBill(v.user, v.package_ids)
                                                    }}
                                                >
                                                    {this.state.formSubmitting && this.state.userCreatingBill === v.user ?
                                                        <div className="spinner-border spinner-border-sm"></div> :
                                                        <span>Bill</span>
                                                    }
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </Table>
                }

                <div className="container-fluid">
                    {this.state.listAlert ? <Alert>{this.state.listAlert}</Alert> :
                        this.state.bills.length === 0 ? null :
                            <Table>
                                <thead>
                                <tr>
                                    <th>Bill</th>
                                    <th title="carrier delivery cost">Carrier, $</th>
                                    <th title="credit card expenses, 3% of carrier cost">CC, $</th>
                                    <th>Bill amount, $</th>
                                    <th>User</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.bills.map((v, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>
                                                    <a href={`https://import.veloxhub.us/api/v1/admin/usps-bills/${v.bill_number}?token=${localStorage.getItem('token')}`}>
                                                        {v.bill_number}
                                                    </a>
                                                </td>
                                                <td>{FormatCents(v.carrier_delivery_cents)}</td>
                                                <td>{FormatCents(v.credit_card_expenses_cents)}</td>
                                                <td>{FormatCents(v.bill_cents)}</td>
                                                <td>{v.user}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </Table>
                    }
                </div>

            </Container>
        )
    }

    newBill(user, packageIDs) {
        this.setState({formSubmitting: true})
        fetch('/api/v1/admin/usps-bills', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${Storage.getToken()}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user: user,
                package_ids: packageIDs,
            }),
        })
            .then(response => {
                switch (response.status) {
                    case 201:
                        response.json()
                            .then(data => {
                                this.setState((prevState) => {
                                    return {
                                        bills: [data, ...prevState.bills],
                                        billCandidates: this.filterCandidates(user),
                                    }
                                })
                            })
                            .catch(err => {
                                this.setState({formAlert: JSON.stringify(err)});
                            })
                        return
                    case 401:
                        Logout();
                        return
                    default:
                        this.setState({formAlert: 'Invalid status: ' + response.status});
                        return
                }
            })
            .catch(err => {
                this.setState({formAlert: JSON.stringify(err)});
            })
            .finally(_ => {
                this.setState({formSubmitting: false, userCreatingBill: ''});
            })
    }

    componentDidMount() {
        this.getBills();
    }

    getBills() {
        this.setState({listLoading: true})
        JwtClient.get(`/api/v1/admin/usps-bills`)
            .then(response => {
                const data = response.data;
                this.setState({
                    bills: data.bills,
                    billCandidates: data.bill_candidates,
                });
            })
            .catch((err) => {
                if (err.response) {
                    if (err.response.status === 401) {
                        Logout();
                    }
                    this.setState({listAlert: 'Error on fetching, status: ' + err.response.status});
                } else {
                    this.setState({listAlert: JSON.stringify(err)});
                }
            })
            .finally(() => {
                this.setState({listLoading: false})
            })
    }

    filterCandidates(billedUser) {
        let res = [];
        for (const a of this.state.billCandidates) {
            if (a.user !== billedUser) {
                res.push(a);
            }
        }
        return res
    }
}
